//#region Libraries
import styled from "styled-components";
//#endregion
import { TDefContent } from "components/CustomTableList/components/TableListItem/ListItem/styles";

export const Cell = styled(TDefContent)`
    background-color: var(--light-blue-2);
    width: 100%;
    &.small {
        padding: 10px 15px;
    }
    & h5 {
        width: max-content;
    }
    &.changed h5 {
        font-weight: bold;
    }
`;
export const NameCell = styled(Cell)`
    & h5 {
        text-align: center;
        padding: 0;
        width: 100px;
    }
`;
export const UserCell = styled(Cell)`
    & h5 {
        text-align: center;
        padding: 0 5px;
        width: 100px;
    }
`;
export const CategoryCell = styled(Cell)`
    & h5 {
        text-align: center;
        padding: 0 5px;
        width: 90px;
    }
`;
export const RoleCell = styled(Cell)`
    & h5 {
        text-align: center;
        padding: 0 5px;
        width: 90px;
    }
`;
export const DateTimeCell = styled(Cell)`
    &.small {
        padding-right: 5px;
        padding-left: 5px;
    }
    & h5 {
        text-align: center;
        padding: 0 5px;
        width: 100px;
    }
`;